import clsx from 'clsx';
import React from 'react';

import FlexLink from '@components/FlexLink';
import { article_path, event_path, highlight_path } from '@routes';
import { getImgixSrc } from '@utils/images';

import { ANCHOR_LINK_CLASSES } from '.';

const Middle = () => (
  <section className="mb-64 flex justify-center">
    <div className="flex max-w-full flex-wrap items-center justify-center gap-48 sm:justify-normal md:max-w-[862px] lg:gap-112">
      <div className="max-w-full sm:max-w-[450px]">
        <h3 className="mb-8 mt-0 font-suisse-works text-headline-md sm:text-left">
          The Information <em className="font-bold text-primary-magenta">Finance</em>
        </h3>
        <div className="font-suisse-intl text-body-lg font-light">
          <p className="mt-0">
            Agile reporting keeping you informed during fast-moving times from an award-winning team
            you can rely on.
          </p>
          <p>
            At a time when much of the media industry is contracting, we are continuing to invest in
            financial coverage. A new newsletter,{' '}
            <FlexLink
              className={clsx(ANCHOR_LINK_CLASSES)}
              href={highlight_path('special-report-m-a')}
            >
              Special Report: M&A
            </FlexLink>
            , will offer a deep dive into topics that matter most to our subscriber community. The
            inaugural{' '}
            <FlexLink
              href={event_path('private-capital-conference')}
              className={clsx(ANCHOR_LINK_CLASSES)}
            >
              Private Capital Conference
            </FlexLink>{' '}
            brought together hundreds of bankers, investors and operators who shared{' '}
            <FlexLink
              href={article_path('highlights-from-the-informations-private-capital-conference')}
              className={clsx(ANCHOR_LINK_CLASSES)}
            >
              candid insights
            </FlexLink>{' '}
            about the IPO market, long-term investment strategy and the rise of sovereign funds.
          </p>
        </div>
      </div>
      <div>
        <img
          className=" max-w-[196px] flex-shrink-0 object-cover"
          src={getImgixSrc({
            path: 'landing_pages/financial_coverages/finance-mobile.gif?auto=compress,format',
            isEnvDependent: false,
          })}
          role="presentation"
          alt="Financial Coverage"
        />
      </div>
    </div>
  </section>
);

export default Middle;
